import { useState, useEffect } from "react";

// true cuando la pantalla mide 768px o menos (celulares).
// Se actualiza solo si giran el teléfono o cambian el tamaño de la ventana.
export const CONSULTA_MOVIL = "(max-width: 768px)";

export default function useEsMovil(consulta = CONSULTA_MOVIL) {
    const leer = () => typeof window !== "undefined" && window.matchMedia(consulta).matches;
    const [esMovil, setEsMovil] = useState(leer);

    useEffect(() => {
        const mq = window.matchMedia(consulta);
        const alCambiar = () => setEsMovil(mq.matches);
        alCambiar();
        mq.addEventListener("change", alCambiar);
        return () => mq.removeEventListener("change", alCambiar);
    }, [consulta]);

    return esMovil;
}